export const RESIZE_THUMB_POSITIONS = {
    TOP_LEFT: 'top-left',
    TOP: 'top',
    TOP_RIGHT: 'top-right',
    LEFT: 'left',
    RIGHT: 'right',
    BOTTOM_LEFT: 'bottom-left',
    BOTTOM: 'bottom',
    BOTTOM_RIGHT: 'bottom-right'
};
